import { PromptTemplateCategory } from '../types';

export const creative: PromptTemplateCategory = {
  title: "Sáng Tạo",
  icon: "✨",
  templates: [
    {
      title: "Truyện Kể Trước Giờ Ngủ",
      content: `Tạo một câu chuyện nhẹ nhàng trước giờ ngủ cho trẻ nhỏ, viết để đọc thành tiếng.
- Nhân vật chính là [một chú cáo nhỏ tốt bụng] tên [Hazel].
- Câu chuyện diễn ra ở [một ngôi làng trong rừng ấm cúng nơi đèn lồng sáng lên vào ban đêm].
- Nhân vật đối mặt với một thử thách nhỏ, nhẹ nhàng: [cô ấy không thể tìm thấy ngôi sao yêu thích trên bầu trời nhiều mây, nên cô theo đom đóm lên đỉnh đồi].
- Kết thúc với một giải pháp yên bình dạy về [sự kiên nhẫn và tin rằng những điều tốt đẹp vẫn ở đó, ngay cả khi bạn không thể nhìn thấy chúng].
- Sử dụng câu ngắn, nhịp nhàng nghe tự nhiên khi đọc thành tiếng.`
    },
    {
      title: "Kể Chuyện Hư Cấu Ngắn",
      content: `Viết một truyện ngắn phù hợp để kể theo phong cách sách nói.
- Thể loại: [bí ẩn đương đại].
- Nhân vật chính là [một thủ thư đã nghỉ hưu nhận thấy điều gì đó kỳ lạ về thói quen hàng ngày của người hàng xóm mới].
- Sự căng thẳng chính là [những chi tiết nhỏ không thể giải thích tích tụ dần dẫn đến một sự tiết lộ bất ngờ nhưng thỏa mãn].
- Giọng điệu: [hồi hộp nhẹ nhàng với chút ấm áp].
- Viết với phong cách rõ ràng, mạch lạc với độ dài câu đa dạng để giữ người nghe tập trung.`
    },
    {
      title: "Đọc Thơ",
      content: `Viết một bài thơ để đọc thành tiếng.
- Chủ đề: [cảm giác của một thành phố thức dậy lúc bình minh].
- Phong cách: [thơ tự do với nhịp nói tự nhiên].
- Tâm trạng: [suy tư và đầy hy vọng].
- Bao gồm chi tiết giác quan sống động: [âm thanh của chuyến xe buýt đầu tiên, ánh sáng chiếu lên vỉa hè ướt, mùi bánh mì mới nướng từ tiệm bánh].
- Sử dụng khoảng dừng và ngắt dòng để hướng dẫn nhịp điệu và hơi thở của người đọc.`
    }
  ]
};
